import { useEffect } from "react";
import { Box } from "@mui/material";

import { Route, Routes } from "react-router-dom";

import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { useNavigate } from "hooks/useNavigate";

import authRoutes from "./authRoutes";

export function AuthLayout() {
  const { authUser } = useAuthenticatedUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (authUser) {
      const url = sessionStorage.getItem("returnURL") ?? "/monitor";

      navigate(url);
    }
  }, [authUser, navigate]);

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Routes>
        {authRoutes.map((route) => (
          <Route key={"path" in route ? route.path : ""} {...route} />
        ))}
      </Routes>
    </Box>
  );
}
